<template>
  <div class="panel">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'TextContainer'
}
</script>

<style scoped lang="sass">
  .panel
    box-sizing: border-box
    border: 1px solid $light-grey
    border-radius: $border-radius
    position: relative
    overflow: auto
    display: block
    padding: (3 * $margin-main-elements)
    margin-bottom: (2 * $margin-main-elements)

    &.danger
      border-width: 2px
      border-color: $red

    &.warning
      border-width: 2px
      border-color: $yellow

    &.success
      border-width: 2px
      border-color: $green

    &.translucent
      border-color: transparent
      padding-top: 0px
      padding-bottom: 0px
      margin-top: -1em
</style>
